import type { ReactNode } from 'react';
import { Box } from '@/ui';

type Props = {
  children: ReactNode;
  hasImage: boolean;
  isCompact: boolean;
};

export const ControlLayer = ({ children, hasImage, isCompact }: Props) => {
  return (
    <Box
      _groupHover={{ opacity: 1 }}
      backdropFilter="blur(10px)"
      bgColor="rgba(255, 255, 255, 0.1)"
      borderRadius="var(--experience-card-radius)"
      inset="0"
      opacity={hasImage ? 0 : 1}
      pos="absolute"
      transition="opacity 0.1s ease-in-out"
      sx={{
        '@container (min-width: 0px)': {
          '&': { display: isCompact ? 'block' : 'none' },
        },
        '@container (min-width: 350px)': {
          '&': { display: isCompact ? 'none' : 'block' },
        },
      }}
    >
      {children}
    </Box>
  );
};
